import React from "react";
import {
    IonList,
    IonItem,
    IonLabel,
    IonText,
    IonBadge,
    IonIcon,
    IonCheckbox,
} from "@ionic/react";
import { cubeOutline, chevronForward } from "ionicons/icons";

interface WarehouseRequest {
    id: string;
    title: string;
    requester: string;
    date: string;
    status: "pending" | "approved" | "rejected";
}

interface WarehouseRequestListProps {
    data: any[];
    onSelect: (data: any) => void;
    selectable?: boolean;
    selectedIds?: string[];
    onToggleSelect?: (id: string) => void;
}

const WarehouseRequestList: React.FC<WarehouseRequestListProps> = ({
    data,
    onSelect,
    selectable = false,
    selectedIds = [],
    onToggleSelect,
}) => {
    return (
        <IonList style={{ background: "none" }}>
            {data.map((req) => (
                <IonItem
                    key={req._id}
                    button
                    onClick={() => (selectable ? onToggleSelect?.(req._id) : onSelect(req))}
                    style={{
                        borderRadius: "10px",
                        marginBottom: "8px",
                        boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
                    }}
                >
                    {selectable ? (
                        <IonCheckbox
                            slot="start"
                            checked={selectedIds.includes(req._id)}
                            style={{ marginRight: "12px", pointerEvents: "none" }}
                        />
                    ) : (
                        <IonIcon
                            slot="start"
                            icon={cubeOutline}
                            style={{ fontSize: "24px", color: "#3880ff" }}
                        />
                    )}

                    <IonLabel>
                        <h2 style={{ fontWeight: 600, fontSize: 16, margin: '0 0 5px 0' }}>{req.approval_title}</h2>
                        <IonText color="medium">
                            <p style={{ margin: '0 0 3px 0' }}>{req.requester_name}</p>
                            <p style={{ margin: 0, fontSize: "0.8rem" }}>{req.request_date}</p>
                        </IonText>
                    </IonLabel>

                    <IonBadge
                        color={
                            req.approval_status === "pending"
                                ? "warning"
                                : req.approval_status === "approved"
                                    ? "success"
                                    : "danger"
                        }
                        style={{ marginRight: "8px" }}
                    >
                        {req.approval_status.toUpperCase()}
                    </IonBadge>

                    {!selectable && <IonIcon icon={chevronForward} color="medium" />}
                </IonItem>
            ))}
        </IonList>
    );
};

export default WarehouseRequestList;
